import type { StaffRole } from "@puszczyk/contracts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { api, unwrap } from "./api";

export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: () => unwrap(api.me.$get()),
  staleTime: 60_000,
});

export type Me = Awaited<ReturnType<NonNullable<typeof meQuery.queryFn>>>;

export function useMe(): Me {
  return useSuspenseQuery(meQuery).data;
}

/** The caller's role in an organization, or null when not a member. */
export function roleIn(me: Me, organizationId: string): StaffRole | null {
  return me.memberships.find((m) => m.organizationId === organizationId)?.role ?? null;
}

/** Observers read only; commanders and admins run the action (docs/05). */
export function canEdit(role: StaffRole | null): boolean {
  return role === "commander" || role === "admin";
}
